import isGenerator from 'is-generator';

class MapperBase {
    constructor(silent, fallback) {
        if (typeof(silent) === 'undefined') {
            this.silent = false;
        }
        else if (typeof(silent) !== 'boolean') {
            throw TypeError('silent must be boolean or undefined type');
        }
        else {
            this.silent = silent;
        }
        
        this.fallback = fallback;
    }

    map(item) {
        try {
            return this.mapSingle(item);
        } catch (error) {
            if (!this.silent){
                throw error;
            }

            return this.getFallback(item, undefined);
        }
    }

    mapSingle(item) {
        throw new Error('map method not implemented');
    }

    getFallback(item, key) {
        return this.fallback;
    }

    handleMappingError(error, mappedCollection, sourceItem, itemKey) {
        if (!this.silent){
            throw error;
        }

        mappedCollection[itemKey] = this.getFallback(sourceItem, itemKey);
    }

    mapCollection(collection) {
        // TODO - make it a generator ?
        if (collection == null || typeof(collection[Symbol.iterator]) !== 'function') {
            throw new TypeError('collection must be iterable');
        }

        if (collection instanceof Array) {
            return this.mapArray(collection);
        }

        if (isGenerator(collection)) {
            return this.mapGenerator(collection);
        }

        if (typeof(collection) === 'object') {
            return this.mapObject(collection);
        }

        throw new TypeError('collection must be an array, object or generator');
    }

    mapArray(array) {
        const out = [];

        for (let i = 0; i < array.length; i++) {
            try {
                out[i] = this.map(array[i]);
            } catch (error) {
                this.handleMappingError(error, out, array[i], i);
            }
        }

        return out;
    }

    mapGenerator(generator) {
        const out = [];

        for (const item of generator) {
            try {
                out.push(this.map(item));
            } catch (error) {
                this.handleMappingError(error, out, item);
            }
        }

        return out;
    }

    mapObject(object) {
        const out = {};

        for (const key in object) {
            
            if (object.hasOwnProperty(key)) {
                try {
                    out[key] = this.map(object[key]);
                } catch (error) {
                    this.handleMappingError(error, out, object[key], key);
                }
            }
        }

        return out;
    }
}

export default MapperBase;